import emailjs from "@emailjs/browser";

export const sendMail = (templateParams, setFn, resetFn) => {
  emailjs
    .send(
      "service_d2tfi3s",
      "template_vt0cmt8",
      templateParams,
      "LzOjI471JLWOOH3hs"
    )
    .then(
      function (response) {
        console.log("SUCCESS!", response.status, response.text);
        if (response.status === 200) {
          setFn(true);
          resetFn({ email: "", name: "", surname: "", subject: "", msg: "" });
        }
      },
      function (error) {
        setFn(false);
        console.log("FAILED...", error);
      }
    );
};
